import { useEffect, useState } from 'react';
import PrismicClient from 'utils/Prismic/PrismicClient';

const INTIAL_STATE = {
  topThingsTitle: '',
  topThingsDescription: '',
  topThingsToDo: [],
  articles: [],
  interlinking: [],
  documentId: '',
};

const usePrismicLocationPage = ({ uid, shouldFetch }) => {
  const [prismicInformation, setPrismicInformation] = useState(INTIAL_STATE);
  const [isPrismicLoading, setLoading] = useState(false);

  useEffect(() => {
    if (shouldFetch) {
      setLoading(true);
      PrismicClient.getLocationPageDocument(uid).then((response) => {
        setLoading(false);
        return setPrismicInformation(response);
      });
    }
  }, [uid, shouldFetch]);

  return {
    ...prismicInformation,
    isPrismicLoading,
  };
};

export default usePrismicLocationPage;
